import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Checkbox,
  Button,
  Modal,
  Icon,
  Select,
  Message,
} from 'semantic-ui-react';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';
import { CANCELATION_REASONS } from '../../constants';

class GuaranteePurchaseCancel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      guaranteePurchaseId: null,
      cancelationReason: null,
      reason: null,
      ineligibleForRepurchase: false,
      skipApplyingCredit: false,
      errors: {},
    };
  }

  componentDidMount() {
    const { guaranteePurchase } = this.props;
    const { id } = guaranteePurchase;

    this.setState({ guaranteePurchaseId: id });
  }

  render() {
    const {
      guaranteePurchase,
      isCancelModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    const {
      errors,
      reason,
      cancelationReason,
      ineligibleForRepurchase,
      skipApplyingCredit,
    } = this.state;

    const onSelectHandler = field => (event, data) => {
      if (field === 'cancelationReason') {
        this.setState({ [field]: data.value, reason: data.value });
      } else {
        this.setState({ [field]: event.target.value });
      }
    };

    const onCheckboxHandler = field => (event, data) => {
      this.setState({ [field]: data.checked });
    };

    const validationRules = {
      reason: 'required',
    };

    const submitForm = () => {
      const {
        guaranteePurchaseId,
        reason: currentReason,
        ineligibleForRepurchase: currentIneligible,
        skipApplyingCredit: currentSkip,
      } = this.state;

      const validation = new Validator(this.state, validationRules);

      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        guaranteePurchaseId,
        cancellation: {
          cancelationReason: currentReason,
          ineligibleForRepurchase: currentIneligible,
          skipApplyingCredit: currentSkip,
        },
      });
      this.setState({ errors: {} });
      return true;
    };

    const {
      isReturned,
      guaranteeOffer: {
        vehicleInformation: { vin },
      },
    } = guaranteePurchase;

    const maxLengthReason = 255;
    const countRestOfReason = reason
      ? maxLengthReason - reason.length
      : maxLengthReason;

    return (
      <Modal
        open={isCancelModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>Cancel Guarantee Purchase for VIN {vin}</Modal.Header>

        {isReturned && (
          <Modal.Content image>
            <Modal.Description>
              <Message negative>
                This vehicle is returned, hence cancel is not allowed.
              </Message>
            </Modal.Description>
          </Modal.Content>
        )}
        {!isReturned && (
          <Modal.Content image>
            <Modal.Description>
              {error && (
                <Message negative>
                  <p>{error}</p>
                </Message>
              )}
              <Form widths='equal'>
                <Form.Field>
                  <Select
                    aria-label='Select cancellation reason'
                    placeholder='Select cancellation reason'
                    options={CANCELATION_REASONS}
                    closeOnBlur
                    value={cancelationReason}
                    onChange={onSelectHandler('cancelationReason')}
                  />
                </Form.Field>
                <Form.Field
                  style={{ width: '100%' }}
                  required
                  error={!isEmpty(errors.reason)}
                >
                  <label htmlFor='reason'>Reason</label>
                  <input
                    id='reason'
                    style={{ width: '100% !important' }}
                    name='reason'
                    value={reason || ''}
                    onChange={onSelectHandler('reason')}
                    maxLength={maxLengthReason}
                  />
                  <span style={{ color: 'red', paddingLeft: '86%' }}>
                    {countRestOfReason} characters left
                  </span>

                  {errors.reason && (
                    <div style={{ color: 'red' }}>{errors.reason}</div>
                  )}
                </Form.Field>
                <Form.Group widths='equal'>
                  <Form.Field>
                    <Checkbox
                      label='Ineligible for repurchase'
                      checked={ineligibleForRepurchase}
                      onChange={onCheckboxHandler('ineligibleForRepurchase')}
                    />
                  </Form.Field>
                  <Form.Field>
                    <Checkbox
                      label='Skip Applying Credit'
                      checked={skipApplyingCredit}
                      onChange={onCheckboxHandler('skipApplyingCredit')}
                    />
                  </Form.Field>
                </Form.Group>
              </Form>
            </Modal.Description>
          </Modal.Content>
        )}
        {!isReturned && (
          <Modal.Actions>
            {submitting && (
              <Button loading positive>
                Submitting...
              </Button>
            )}
            {!submitting && (
              <Button color='green' onClick={submitForm} inverted>
                <Icon name='checkmark' /> Submit
              </Button>
            )}
            <Button onClick={onCloseHandler}>Cancel</Button>
          </Modal.Actions>
        )}
      </Modal>
    );
  }
}

GuaranteePurchaseCancel.propTypes = {
  guaranteePurchase: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isReturned: PropTypes.bool,
    guaranteeOffer: PropTypes.shape({
      vehicleInformation: PropTypes.shape({
        vin: PropTypes.string,
      }),
    }),
  }),
  isCancelModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

export default GuaranteePurchaseCancel;
